<template>
    <div>
        <div v-if="ready">
            <vs-divider>Docentes por institución</vs-divider>
            <apexchart type="pie" style="margin-top: 90px;margin-left: 50px;" width="380" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>
<script>
import chart from "vue-apexcharts";
export default{
    components: { apexchart: chart },
    data(){
        return{   
            series: [],
            chartOptions: {
                chart: {
                    width: 380,
                    type: 'donut',
                },
                dataLabels: {
                    enabled: true
                },
                labels: [],
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    width: 200
                    },
                    legend: {
                     position: 'bottom'
                    }
                }
                }],
            },
            ready:false,
        }
    },
    mounted() {
        let me = this;
        me.reporteDocentesxInstitucion()
    },
    methods: {
        reporteDocentesxInstitucion(){
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url+'institucion?reporteDocentesxInstitucion=yes')
            .then(function (res) {
                me.arregloReporte = res.data
                if(me.arregloReporte.length > 0){
                setTimeout(() => {
                    me.renderReporte(me.arregloReporte)
                }, 1000)
                }
                me.$vs.loading.close()
            })
            .catch(function (error) {
                console.log(error + ' error');
                me.$vs.loading.close()
            })
        },
        renderReporte(datos){
            let me = this
            var valores = []
            datos.map((p,key) =>{
            me.chartOptions.labels[key] = p.nombreInstitucion
            valores.push(p.contador)
            })
            this.series = valores;
            me.ready = true
        },
    },
}
</script>